<template>
  <div>
    <div class="product-add">
      <el-steps :active="stepActive" finish-status="success">
        <el-step title="签约信息"/>
        <el-step title="资质信息"/>
        <el-step title="支付款项"/>
        <el-step title="签约审核"/>
        <el-step title="开通完成"/>
      </el-steps>
    </div>
    <el-divider><span class="icon iconfont icon-lakalazhifu">&nbsp;拉卡拉支付</span></el-divider>

    <!--签约信息-->
    <el-form v-if="stepActive===0" ref="baseInfo" size="small" :model="form.baseInfo" :rules="stepForm_rules0"
             label-width="200px" :disabled="payInfo.op==='view'" style="padding-bottom: 20px">
      <!--超级管理员信息-->
      <div class="common-form">主体资料</div>
      <el-form-item label="主体类型" prop="subject_type">
        <el-radio-group v-model="form.baseInfo.subject_type" @input="subjectTypeChange">
          <el-radio border label="SUBJECT_TYPE_INDIVIDUAL">小微商户</el-radio>
          <el-radio border label="SUBJECT_TYPE_ENTERPRISE">营业执照商户</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--经营资料-->
      <div class="common-form">经营资料</div>
      <el-form-item label="商户注册名称" prop="merRegName">
        <template slot="label">
            <span>商户注册名称
              <el-tooltip class="item" effect="dark" placement="right">
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;"></i>
                <div slot="content">
                  <p>小微商户，商户注册名称必须如下格式</p>
                  <p>商户_张三</p>
                </div>
              </el-tooltip>
            </span>
        </template>
        <el-input type="text" v-model="form.baseInfo.merRegName" class="max-w460"></el-input>
        <!--        <div class="gray9">权重越大，等级越高</div>-->
      </el-form-item>
      <el-form-item label="商户经营名称" prop="merBizName">
        <el-input type="text" v-model="form.baseInfo.merBizName" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商户地区" prop="merRegDistCode">
        <el-cascader
          ref="areaCascader"
          placeholder="商户地区"
          v-model="form.baseInfo.merRegDistCode"
          :options="areaList"
          filterable
          class="max-w460 f-item"
          @change="handleBankAddressChange"></el-cascader>
      </el-form-item>
      <el-form-item label="商户详细地址" prop="merRegAddr">
        <el-input type="textarea" v-model="form.baseInfo.merRegAddr" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商户MCC编号" prop="mccCode">
        <el-input type="text" v-model="form.baseInfo.mccCode" class="max-w460" :disabled="true"></el-input>
      </el-form-item>
      <!--结算银行-->
      <div class="common-form">结算银行账户</div>
      <el-form-item label="账户类型" prop="acctTypeCode">
        <el-radio-group v-model="form.baseInfo.acctTypeCode"
                        :disabled="form.baseInfo.subject_type !== 'SUBJECT_TYPE_INDIVIDUAL'"
                        @input="acctTypeCodeChange">
          <el-radio label="58">经营者个人银行卡</el-radio>
          <el-radio label="57">对公银行账户</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="银行账号" prop="acctNo">
        <el-input v-model="form.baseInfo.acctNo" type="number" class="max-w460"
                  @change="searchBanksByBankAccount"></el-input>
      </el-form-item>
      <el-form-item label="开户名称" prop="acctName">
        <el-input type="text" v-model="form.baseInfo.acctName" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="开户银行" prop="openningBankName">
        <el-select size="small" v-model="form.baseInfo.openningBankName" placeholder="开户银行" class="max-w460 f-item">
          <el-option v-for="(item, index) in bankList" :key="index" :label="item.mergerName"
                     :value="item.mergerName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结算账户开户行号" prop="openningBankCode">
        <el-input type="text" v-model="form.baseInfo.openningBankCode" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="结算账户清算行号" prop="clearingBankCode">
        <el-input type="text" v-model="form.baseInfo.clearingBankCode" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="结算银行卡正面" prop="bank_card">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('bank_card')">选择图片</el-button>
          <div v-if="form.baseInfo.bank_card !== undefined" class="img">
            <img :src="bank_cardFilePath" width="200" height="200"/>
          </div>
        </el-row>
      </el-form-item>
    </el-form>

    <!--资质信息-->
    <el-form v-if="stepActive===1" ref="qualificationInfo" size="small" :model="form.qualificationInfo"
             :rules="stepForm_rules1"
             label-width="200px" :disabled="payInfo.op==='view'">
      <!--营业执照-->
      <div class="common-form">营业信息</div>
      <div v-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_ENTERPRISE'">
        <el-form-item label="营业执照照片" prop="license_copy">
          <el-row>
            <el-button icon="el-icon-picture-outline" @click="openUpload('license_copy')">选择图片</el-button>
            <div v-if="form.qualificationInfo.license_copy !== undefined" class="img">
              <img :src="license_copyFilePath" width="200" height="200"/>
            </div>
          </el-row>
        </el-form-item>
        <el-form-item label="注册号/统一社会信用代码" prop="merBlis">
          <el-input type="text" v-model="form.qualificationInfo.merBlis" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="商户名称" prop="merchant_name">
          <el-input type="text" v-model="form.qualificationInfo.merchant_name" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="个体户经营者/法人姓名" prop="legal_person">
          <el-input v-model="form.qualificationInfo.legal_person" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="license_address">
          <el-input v-model="form.qualificationInfo.license_address" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="有效期类型" prop="period_type">
          <el-radio-group v-model="form.qualificationInfo.period_type" @input="period_typeChange">
            <el-radio label="0">定期</el-radio>
            <el-radio label="1">长期有效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效期限开始日期" prop="merBlisStDt">
          <el-date-picker
            size="small"
            v-model="form.qualificationInfo.merBlisStDt"
            align="right"
            unlink-panels
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options='pickerAddStart(form.qualificationInfo.merBlisExpDt)'
            @change="($event)=>limitPeriodDate('start',$event)"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="有效期限结束日期" prop="merBlisExpDt" v-if="form.qualificationInfo.period_type ==='0'">
          <el-date-picker
            size="small"
            v-model="form.qualificationInfo.merBlisExpDt"
            align="right"
            unlink-panels
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options='pickerAddEnd(form.qualificationInfo.merBlisStDt)'
            @change="($event)=>limitPeriodDate('end',$event)"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div v-else-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_INDIVIDUAL'">
        <el-form-item label="商户门头照" prop="merchant_photo">
          <el-row>
            <el-button icon="el-icon-picture-outline" @click="openUpload('merchant_photo')">选择图片</el-button>
            <div v-if="form.qualificationInfo.merchant_photo !== undefined" class="img">
              <img :src="merchant_photoFilePath" width="200" height="200"/>
            </div>
          </el-row>
        </el-form-item>
        <el-form-item label="商铺内部照片" prop="shopinner">
          <el-row>
            <el-button icon="el-icon-picture-outline" @click="openUpload('shopinner')">选择图片</el-button>
            <div v-if="form.qualificationInfo.shopinner !== undefined" class="img">
              <img :src="shopinnerFilePath" width="200" height="200"/>
            </div>
          </el-row>
        </el-form-item>
      </div>
      <!--超级管理员信息-->
      <div class="common-form">经营者/法人身份证件</div>
      <el-form-item label="商户经营内容" prop="merBusiContent">
        <el-select v-model="form.qualificationInfo.merBusiContent" placeholder="请选择商户经营内容">
          <el-option label="餐饮、宾馆、娱乐、珠宝金饰、工艺美术品" value="640" disabled></el-option>
          <el-option label="房地产汽车类" value="641" disabled>
          </el-option>
          <el-option label="百货、中介、培训、景区门票等" value="642" disabled>
          </el-option>
          <el-option label="批发类商户" value="643" disabled>
          </el-option>
          <el-option label="加油、超市类" value="644" disabled>
          </el-option>
          <el-option label="交通运输售票" value="645" disabled>
          </el-option>
          <el-option label="水电气缴费" value="646" disabled>
          </el-option>
          <el-option label="政府类" value="647" disabled>
          </el-option>
          <el-option label="便民类" value="648" disabled>
          </el-option>
          <el-option label="公立医院、公立学校、慈善" value="649" disabled>
          </el-option>
          <el-option label="宾馆餐饮娱乐类" value="650" disabled>
          </el-option>
          <el-option label="房产汽车类" value="651" disabled>
          </el-option>
          <el-option label="批发类" value="652" disabled>
          </el-option>
          <el-option label="超市加油类" value="653" disabled>
          </el-option>
          <el-option label="一般类商户" value="654">
          </el-option>
          <el-option label="三农商户" value="655">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件类型" prop="larIdType">
        <el-select v-model="form.qualificationInfo.larIdType" placeholder="请选择">
          <el-option label="中国大陆居民-身份证" value="01"></el-option>
          <el-option label="其他国家或地区居民-护照" value="02" disabled>
          </el-option>
          <el-option label="港澳通行证" value="03" disabled>
          </el-option>
          <el-option label="台胞证" value="04" disabled>
          </el-option>
          <el-option label="其它证件" value="99" disabled>
          </el-option>
        </el-select>
      </el-form-item>

      <!--营业执照-->
      <div class="common-form">身份证信息</div>
      <el-form-item label="身份证人像面照片" prop="id_card_copy">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('id_card_copy')">选择图片</el-button>
          <div v-if="form.qualificationInfo.id_card_copy !== undefined" class="img">
            <img :src="id_card_copyFilePath" width="200" height="200"/>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="身份证国徽面照片" prop="id_card_national">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('id_card_national')">选择图片</el-button>
          <div v-if="form.qualificationInfo.id_card_national !== undefined" class="img">
            <img :src="id_card_nationalFilePath" width="200" height="200"/>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="身份证姓名" prop="larName">
        <el-input type="text" v-model="form.qualificationInfo.larName" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="身份证号码" prop="larIdcard">
        <el-input type="text" v-model="form.qualificationInfo.larIdcard" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="身份证有效期类型" prop="card_period_type">
        <el-radio-group v-model="form.qualificationInfo.card_period_type" @input="card_period_typeChange">
          <el-radio label="0">定期</el-radio>
          <el-radio label="1">长期有效</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="身份证有效期开始时间" prop="card_merBlisStDt">
        <el-date-picker
          size="small"
          v-model="form.qualificationInfo.card_merBlisStDt"
          align="right"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options='pickerAddStart(form.qualificationInfo.card_merBlisExpDt)'
          @change="($event)=>limitDate('start',$event)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="身份证有效期结束时间" prop="card_merBlisExpDt"
                    v-if="form.qualificationInfo.card_period_type ==='0'">
        <el-date-picker
          size="small"
          v-model="form.qualificationInfo.card_merBlisExpDt"
          align="right"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options='pickerAddEnd(form.qualificationInfo.card_merBlisStDt)'
          @change="($event)=>limitDate('end',$event)"
        ></el-date-picker>
      </el-form-item>

      <!--超级管理员信息-->
      <div class="common-form">超级管理员信息</div>
      <el-form-item label="超级管理员姓名" prop="merContactName">
        <el-input type="text" v-model="form.qualificationInfo.merContactName" prefix-icon="el-icon-user" clearable
                  :placeholder="$t('login.user')" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="超级管理员联系手机" prop="merContactMobile">
        <el-input v-model="form.qualificationInfo.merContactMobile" prefix-icon="el-icon-phone" clearable
                  class="max-w460"
                  :placeholder="$t('login.mobilePlaceholder')">
        </el-input>
      </el-form-item>
    </el-form>

    <!--支付款项-->
    <el-form v-if="stepActive===2" ref="stepForm_2" size="small" :model="form.pay" :rules="stepForm_rules2"
             label-width="200px" :disabled="payInfo.op==='view'">
      <!--超级管理员信息-->
      <div class="common-form">支付款项</div>
      <el-select v-model="form.pay.activities_rate" placeholder="请选择">
        <el-option label="零售（0.6%，T+1）" value="0.6"></el-option>
      </el-select>
    </el-form>

    <!--签约审核-->
    <el-form v-if="stepActive===3" ref="stepForm_3" size="small" :model="stepForm_3" :rules="stepForm_rules3"
             label-width="200px" :disabled="payInfo.op==='view'">
      <!--超级管理员信息-->
      <div class="common-form">超级管理员信息</div>
    </el-form>

    <!--开通完成-->
    <div v-if="stepActive===4">
      <el-result icon="success" title="注册成功" sub-title="审核完成后，您可以使用登录账号以及手机号登录系统">
        <template #extra>
          <el-button type="primary" @click="goLogin">前去登录</el-button>
        </template>
      </el-result>
    </div>

    <div class="common-button-wrapper">
      <!--      <el-button type="danger" @click="repickPayType">选择平台</el-button>-->
      <el-button v-if="stepActive>0 && stepActive<3" @click="pre">上一步</el-button>
      <el-button v-if="stepActive<2" type="primary" @click="next">下一步</el-button>
      <el-button v-if="stepActive===2" type="primary" @click="doSave">提交</el-button>
    </div>

    <!--上传图片组件-->
    <Upload v-if="isupload" :config="uploadConfig" :isupload="isupload" @returnImgs="returnImgsFunc">
      上传图片
    </Upload>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import SubApplymentApi from '@/api/subApplyment.js';
import DataApi from '@/api/data.js';
import Upload from '@/components/file/Upload';
import moment from 'moment'
import {isNil} from 'lodash-es';

export default {
  name: "LakalaApply",
  props: {
    payInfo: {
      type: Object,
      default: {}
    },
  },
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      loading: false,
      stepActive: 0,
      uploadConfig: {
        uploadType: 'Local'
      },
      /*切换菜单*/
      license_copyFilePath: '',
      id_card_copyFilePath: '',
      id_card_nationalFilePath: '',
      merchant_photoFilePath: '',
      bank_cardFilePath: '',
      shopinnerFilePath: '',
      /*是否上传图片*/
      isupload: false,
      /*银行列表*/
      bankList: [],
      /*省市区*/
      areaList: [],
      fileType: 'logo',
      /*form表单数据*/
      form: {
        applymentId: '',
        applymentNo: '',
        applymentType: 40,
        baseInfo: {
          subject_type: 'SUBJECT_TYPE_INDIVIDUAL',
          merRegName: '商户_',
          merBizName: '',
          acctTypeCode: '58',
          acctName: '',
          openningBankName: '',
          openningBankCode: '',
          clearingBankCode: '',
          acctNo: '',
          merRegDistCode: '',
          merRegAddr: '',
          mccCode: '5963',
          bank_card: undefined,
        },
        qualificationInfo: {
          merContactName: '',
          merContactMobile: '',
          license_copy: undefined,
          merBlis: '',
          merchant_name: '',
          legal_person: '',
          license_address: '',
          merBlisStDt: '',
          merBlisExpDt: '',
          merBusiContent: '654',
          larIdType: '01',
          id_card_copy: undefined,
          id_card_national: undefined,
          merchant_photo: undefined,
          shopinner: undefined,
          larName: '',
          larIdcard: '',
          card_period_type: '0',
          period_type: '0',
          card_merBlisStDt: '',
          card_merBlisExpDt: '',
          sales_scenes_type: [],
          mini_program_appid: '',
          mini_program_sub_appid: '',
          mini_program_pics: [],
          store_entrance_pic: [],
          indoor_pic: [],
          domain: '',
          web_authorisation: '',
          mp_appid: '',
          biz_store_name: '',
          biz_address_code: '',
          biz_store_address: '',
          biz_sub_appid: '',
          mp_sub_appid: '',
          mp_pics: [],
          app_appid: '',
          app_sub_appid: '',
          app_pics: [],
        },
        pay: {
          activities_rate: '0.6',
        },
        stepForm_3: {},
        stepForm_4: {},
      },
      stepForm_rules0: {
        subject_type: [
          {required: true, message: '请选择主体类型'}
        ],
        merRegName: [
          {required: true, message: '请输入商户简称'}
        ]
        , mccCode: [
          {required: true, message: '请输入商户MCC编号'}
        ],
        acctTypeCode: [
          {required: true, message: '请选择账户类型'}
        ],
        merRegAddr: [
          {required: true, message: '请输入商户详细地址'}
        ],
        merRegDistCode: [
          {required: true, message: '请选择商户地区'}
        ],
        acctName: [
          {required: true, message: '请输入开户名称'}
        ],
        openningBankName: [
          {required: true, message: '请选择开户银行'}
        ],
        openningBankCode: [
          {required: true, message: '请输入结算账户开户行号'}
        ],
        clearingBankCode: [
          {required: true, message: '请输入结算账户清算行号'}
        ],
        acctNo: [
          {required: true, message: '请输入银行账号'}
        ],
        bank_card: [
          {required: true, message: '结算银行卡正面'}
        ],
      },
      stepForm_rules1: {
        merBusiContent: [
          {required: true, message: '请选择商户经营内容'}
        ],
        merContactName: [
          {required: true, message: '请输入超级管理员姓名', trigger: ['blur', 'change']}
        ],
        merContactMobile: [
          {required: true, message: '请输入超级管理员联系手机', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change']}
        ],
        license_copy: [
          {required: true, message: '请上传营业执照照片'}
        ],
        merBlis: [
          {required: true, message: '请输入注册号/统一社会信用代码'}
        ],
        merchant_name: [
          {required: true, message: '请输入商户名称'}
        ],
        legal_person: [
          {required: true, message: '请输入个体户经营者/法人姓名'}
        ],
        license_address: [
          {required: true, message: '请输入注册地址'}
        ],
        merBlisStDt: [
          {required: true, message: '请选择有效期限开始日期', trigger: ['blur', 'change']}
        ],
        merBlisExpDt: [
          {required: true, message: '请选择有效期限结束日期', trigger: ['blur', 'change']}
        ],
        larIdType: [
          {required: true, message: '请选择证件类型'}
        ],
        merchant_photo: [
          {required: true, message: '请上传商户门头照'}
        ],
        shopinner: [
          {required: true, message: '请上传商铺内部照片'}
        ],
        id_card_copy: [
          {required: true, message: '请上传身份证人像面照片'}
        ],
        id_card_national: [
          {required: true, message: '请上传身份证国徽面照片'}
        ],
        larName: [
          {required: true, message: '请输入身份证姓名'}
        ],
        larIdcard: [
          {required: true, message: '请输入身份证号码'}
        ],
        card_period_type: [
          {required: true, message: '请选择身份证有效期类型'}
        ],
        card_merBlisStDt: [
          {required: true, message: '请选择身份证有效期限开始日期', trigger: ['blur', 'change']}
        ],
        card_merBlisExpDt: [
          {required: true, message: '请选择身份证有效期限结束日期', trigger: ['blur', 'change']}
        ],
        mini_program_appid: [
          {required: true, message: '请输入服务商小程序APPID'}
        ],
        mini_program_sub_appid: [
          {required: true, message: '请输入商家小程序APPID'}
        ],
        mp_appid: [
          {required: true, message: '请输入服务商公众号APPID'}
        ],
        mp_sub_appid: [
          {required: true, message: '请输入商家公众号APPID'}
        ],
        app_appid: [
          {required: true, message: '请输入服务商应用APPID'}
        ],
        app_sub_appid: [
          {required: true, message: '请输入商家应用APPID'}
        ],
        // sales_scenes_type: [
        //   {type: 'array', required: true, message: '请选择经营场景类型'}
        // ],
        mini_program_pics: [
          {required: true, message: '请上传小程序截图'}
        ],
        domain: [
          {required: true, message: '请输入互联网网站域名'}
        ],
        web_authorisation: [
          {required: true, message: '请上传网站授权函'}
        ],

      },
      stepForm_rules2: {},
      stepForm_rules3: {},
      stepForm_rules4: {},
      pickerAddStart(val) {
        return {
          disabledDate(time) {
            if (val) {
              const start = moment(new Date(val), 'YYYY-MM-DD')
              return moment(time.getTime()).isAfter(start);
            }
          },
        }
      },
      pickerAddEnd(val) {
        return {
          disabledDate(time) {
            if (val) {
              const start = moment(new Date(val), 'YYYY-MM-DD')
              return moment(time.getTime()).isBefore(start);
            }
          },
        }
      },
    }
  },
  inject: [],
  mounted() {
    this.getAreaData();
    this.getBankList();
  },
  methods: {
    // 添加这个方法是因为，点击“确定”按钮会获取到当前时间，不受picker-options的限制并赋值到输入框中
    limitDate(type, date) {
      var dateTime = new Date(date).getTime();
      //开始时间的时间戳不能大于结束时间
      if (type === "start" && dateTime && this.form.qualificationInfo.card_merBlisExpDt && dateTime > new Date(this.form.qualificationInfo.card_merBlisExpDt).getTime()) {
        this.$message.error("开始时间不能大于结束时间！");
        this.form.qualificationInfo.card_merBlisStDt = "";
      }
      if (type === "end" && dateTime && this.form.qualificationInfo.card_merBlisStDt && dateTime < new Date(this.form.qualificationInfo.card_merBlisStDt).getTime()) {
        this.$message.error("结束时间不能小于开始时间！");
        this.form.qualificationInfo.card_merBlisExpDt = "";
      }
    },
    limitPeriodDate(type, date) {
      var dateTime = new Date(date).getTime();
      //开始时间的时间戳不能大于结束时间
      if (type === "start" && dateTime && this.form.qualificationInfo.merBlisExpDt && dateTime > new Date(this.form.qualificationInfo.merBlisExpDt).getTime()) {
        this.$message.error("开始时间不能大于结束时间！");
        this.form.qualificationInfo.merBlisStDt = "";
      }
      if (type === "end" && dateTime && this.form.qualificationInfo.merBlisStDt && dateTime < new Date(this.form.qualificationInfo.merBlisStDt).getTime()) {
        this.$message.error("结束时间不能小于开始时间！");
        this.form.qualificationInfo.merBlisExpDt = "";
      }
    },
    sales_scenes_typeChange() {

    },
    repickPayType() {

    },
    pre() {
      this.stepActive -= 1
    },
    getFormName() {
      let text = '';
      switch (this.stepActive) {
        case 0:
          text = 'baseInfo'
          break;
        case 1:
          text = 'qualificationInfo'
          break;
        case 2:
          text = 'stepForm_2'
          break;
        case 3:
          text = 'stepForm_3'
          break;
      }
      return text;
    },
    next() {
      let self = this;
      const formName = self.getFormName();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (self.stepActive < 5) {
            self.stepActive += 1
          }
        } else {
          return false
        }
      })
    },
    doSave() {
      let self = this;
      if (self.payInfo.op === 'edit') {
        self.onEditSubmit();
      } else {
        self.save();
      }
    },
    save() {
      let self = this;
      const formName = self.getFormName()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          self.loading = true;
          let Params = {
            ...self.form
          };
          SubApplymentApi.addLakalaApplyment(Params)
            .then(res => {
              self.loading = false;
              self.stepActive += 1
            })
            .catch(error => {
              self.loading = false;
            });
        } else {
          return false
        }
      })
    },
    //提交表单
    onEditSubmit() {
      let self = this;
      const formName = self.getFormName()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          self.loading = true;
          let Params = {
            ...self.form
          };
          SubApplymentApi.editLakalaApplyment(Params)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，编辑成功',
                type: 'success'
              });
              self.$router.push('/setting/applyment/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    /*上传*/
    openUpload(e) {
      this.fileType = e;
      this.isupload = true;
      if (this.fileType === 'license_copy' || this.fileType === 'id_card_national' || this.fileType === 'id_card_copy' || this.fileType === 'merchant_photo' || this.fileType === 'bank_card' || this.fileType === 'shopinner') {
        this.uploadConfig = {
          total: 1,
          maxSelect: 1,
          uploadType: 'Local',
          fileType: 'image'
        };
      } else if (this.fileType === 'mp_pics' || this.fileType === 'app_pics' || this.fileType === 'mini_program_pics' || this.fileType === 'store_entrance_pic' || this.fileType === 'indoor_pic' || this.fileType === 'qualifications' || this.fileType === 'activities_additions') {
        this.uploadConfig = {
          total: 5,
          maxSelect: 5,
          uploadType: 'Local',
          fileType: 'image'
        };
      }
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.fileType == 'license_copy') {
          this.license_copyFilePath = e[0].filePath;
          this.form.qualificationInfo.license_copy = e[0];
        } else if (this.fileType == 'id_card_national') {
          this.id_card_nationalFilePath = e[0].filePath;
          this.form.qualificationInfo.id_card_national = e[0];
        } else if (this.fileType == 'id_card_copy') {
          this.id_card_copyFilePath = e[0].filePath;
          this.form.qualificationInfo.id_card_copy = e[0];
        } else if (this.fileType == 'merchant_photo') {
          this.merchant_photoFilePath = e[0].filePath;
          this.form.qualificationInfo.merchant_photo = e[0];
        } else if (this.fileType == 'bank_card') {
          this.bank_cardFilePath = e[0].filePath;
          this.form.baseInfo.bank_card = e[0];
        } else if (this.fileType == 'shopinner') {
          this.shopinnerFilePath = e[0].filePath;
          this.form.qualificationInfo.shopinner = e[0];
        } else if (this.fileType == 'mp_pics') {
          let imgs = this.form.qualificationInfo.mp_pics.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'mp_pics', imgs);
        } else if (this.fileType == 'mini_program_pics') {
          let imgs = this.form.qualificationInfo.mini_program_pics.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'mini_program_pics', imgs);
        } else if (this.fileType == 'store_entrance_pic') {
          let imgs = this.form.qualificationInfo.store_entrance_pic.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'store_entrance_pic', imgs);
        } else if (this.fileType == 'indoor_pic') {
          let imgs = this.form.qualificationInfo.indoor_pic.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'indoor_pic', imgs);
        } else if (this.fileType == 'app_pics') {
          let imgs = this.form.qualificationInfo.app_pics.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'app_pics', imgs);
        }

      }
      this.isupload = false;
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*删除设备图片*/
    deleteImg(arry, index) {
      arry.splice(index, 1);
    },
    subjectTypeChange(e) {
      let self = this;
      if (e !== 'SUBJECT_TYPE_INDIVIDUAL') {
        self.form.baseInfo.acctTypeCode = '57';
      } else if (e === 'SUBJECT_TYPE_INDIVIDUAL') {
        self.form.baseInfo.acctTypeCode = '58';
      }
      // self.form.baseInfo.acctName = '';
      // self.form.baseInfo.openningBankName = '';
      // self.form.baseInfo.acctNo = '';
      self.getBankList();
    },
    acctTypeCodeChange(e) {
      let self = this;
      self.form.baseInfo.acctName = '';
      self.form.baseInfo.openningBankName = '';
      self.form.baseInfo.acctNo = '';
      self.getBankList();
    },
    period_typeChange(e) {
      let self = this;
      if (self.form.qualificationInfo.period_type == '0') {
        if (isNil(self.form.qualificationInfo.merBlisStDt)) {
          self.form.qualificationInfo.merBlisStDt = ''
        } else {
          //默认增加10年
          self.form.qualificationInfo.merBlisStDt = moment(new Date(self.form.qualificationInfo.merBlisStDt), 'YYYY-MM-DD').add(10, 'years').format('YYYY-MM-DD')
        }
      } else {
        self.form.qualificationInfo.merBlisExpDt = '长期';
      }
    },
    card_period_typeChange(e) {
      let self = this;
      if (self.form.qualificationInfo.card_period_type == '0') {
        if (isNil(self.form.qualificationInfo.card_merBlisStDt)) {
          self.form.qualificationInfo.card_merBlisExpDt = ''
        } else {
          //默认增加10年
          self.form.qualificationInfo.card_merBlisExpDt = moment(new Date(self.form.qualificationInfo.card_merBlisStDt), 'YYYY-MM-DD').add(10, 'years').format('YYYY-MM-DD')
        }
      } else {
        self.form.qualificationInfo.card_merBlisExpDt = '长期';
      }
    },
    getAreaData() {
      let self = this;
      DataApi.getLakalaRegion({}, true)
        .then(res => {
          self.areaList = res.data;
        })
        .catch(error => {
        });
    },
    getBankList() {
      let self = this;
      if (self.form.baseInfo.acctTypeCode === '58') {

      } else {

      }
      DataApi.getBanking({level: 1}, true)
        .then(res => {
          self.bankList = res.data;
        })
        .catch(error => {
        });
    },
    handleBankAddressChange(item) {

    },
    searchBanksByBankAccount(queryString) {
      let self = this;
      if (self.form.baseInfo.acctTypeCode === '58') {
        DataApi.cardBin({accountNumber: queryString}, true)
          .then(res => {
            //仅获取第一个
            let data = res.data;
            self.form.baseInfo.openningBankName = data.bankName;
            self.form.baseInfo.openningBankCode = data.bankCode;
            self.form.baseInfo.clearingBankCode = data.clearingBankCode;
          })
          .catch(error => {
            self.form.baseInfo.openningBankName = '';
          });
      }
    },
    getData(applymentId) {
      let self = this;
      // 取到路由带过来的参数
      SubApplymentApi.applymentDetail({
        applymentId: applymentId
      }, true)
        .then(res => {
          let detail = res.data;
          // 将数据放在当前组件的数据内
          self.form.baseInfo = JSON.parse(detail.baseInfo);
          self.form.qualificationInfo = JSON.parse(detail.qualificationInfo);

          self.license_copyFilePath = (self.form.qualificationInfo.license_copy || {}).filePath;
          self.id_card_nationalFilePath = (self.form.qualificationInfo.id_card_national || {}).filePath;
          self.id_card_copyFilePath = (self.form.qualificationInfo.id_card_copy || {}).filePath;
          self.merchant_photoFilePath = (self.form.qualificationInfo.merchant_photo || {}).filePath;
          self.bank_cardFilePath = (self.form.baseInfo.bank_card || {}).filePath;
          self.shopinnerFilePath = (self.form.qualificationInfo.shopinner || {}).filePath;

          self.form.applymentId = detail.applymentId;
          self.form.applymentNo = detail.applymentNo;
        })
        .catch(error => {

        });

    },
  },
  watch: {
    'payInfo': {
      handler(values, oldVal) {
        let oldTimeStamp = (typeof oldVal === 'undefined' ? 0 : oldVal.timeStamp);
        if (values.timeStamp && values.timeStamp != oldTimeStamp && values.applymentId) {
          this.getData(values.applymentId)
        }
      },
      immediate: true,
      deep: true
    },
  }
}
</script>

<style lang="scss" scoped>

.bank-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .code {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .code {
      color: #ddd;
    }
  }
}

.tips {
  color: #ccc;
}

.subject-wrap {
  background: #f6f8fb !important;
}

.product-add {
  padding-bottom: 20px;
}

.f-item {
  width: 100%;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>




// WEBPACK FOOTER //
// src/views/setting/applyment/part/Lakala.vue